import { Config } from '@flowwai-frontend/shared/constants'
import { StatsigTier } from '../types/index'

import { DynamicFeatureTogglesTier } from '../constants/DynamicFeatureConstants'

export const getDynamicFeatureTogglesTier = (): DynamicFeatureTogglesTier => {
   const envName = Config.ENV_NAME

   switch (envName) {
      case 'DEV':
         return DynamicFeatureTogglesTier.DEVELOPMENT
      case 'GAMMA':
         return DynamicFeatureTogglesTier.DEVELOPMENT
      case 'BN_GAMMA':
         return DynamicFeatureTogglesTier.DEVELOPMENT
      case 'BN_UAT':
         return DynamicFeatureTogglesTier.STAGING
      case 'BN_PROD':
         return DynamicFeatureTogglesTier.PRODUCTION
      default:
         return DynamicFeatureTogglesTier.DEVELOPMENT
   }
}
